module.exports = __webpack_public_path__ + "static/media/gomphocerippus_rufus_002_APA.1aa33339.png";